import React from 'react'
import Container from '../../pb_container/_container'

const ContainerDefault = (props) => (
  <Container
      {...props}
  >
    Hello, I am a div container
  </Container>
)

export default ContainerDefault
